import React from 'react';
import { TableContainer, Paper, Typography, Table, TableHead, TableRow, TableCell, TableSortLabel, TableBody, TablePagination, Box } from '@mui/material';

export function SalesTable({
  salesOrderBy,
  salesOrder,
  handleSalesRequestSort,
  sortedSales,
  salesPage,
  salesRowsPerPage,
  handleSalesChangePage,
  handleSalesChangeRowsPerPage,
  recentSales,
  accountBalance,
}) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      {/* <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h6" sx={{ fontWeight: 'medium' }}>
          Sales
        </Typography>
      </Box> */}
      
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sales table">
          <TableHead>
            <TableRow>
              <TableCell 
                sx={{ 
                  fontWeight: 'bold',
                  width: '40%',
                  backgroundColor: 'background.paper'
                }}
              >
                Catch Report
              </TableCell>
              <TableCell 
                align="right" 
                sx={{ 
                  fontWeight: 'bold',
                  width: '30%',
                  backgroundColor: 'background.paper'
                }}
              >
                <TableSortLabel
                  active={salesOrderBy === 'purchaseCost'}
                  direction={salesOrderBy === 'purchaseCost' ? salesOrder : 'asc'}
                  onClick={() => handleSalesRequestSort('purchaseCost')}
                >
                  Price
                </TableSortLabel>
              </TableCell>
              <TableCell 
                align="right" 
                sx={{ 
                  fontWeight: 'bold',
                  width: '30%',
                  backgroundColor: 'background.paper'
                }}
              >
                <TableSortLabel
                  active={salesOrderBy === 'purchaseDate'}
                  direction={salesOrderBy === 'purchaseDate' ? salesOrder : 'asc'}
                  onClick={() => handleSalesRequestSort('purchaseDate')}
                >
                  Date
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedSales
              .slice(salesPage * salesRowsPerPage, salesPage * salesRowsPerPage + salesRowsPerPage)
              .map((sale) => (
                <TableRow key={sale.id} hover>
                  <TableCell component="th" scope="row">
                    <a 
                      href={`/single?imageId=${sale.imageId}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none', color: '#1976d2' }}
                    >
                      Catch Report
                    </a>
                  </TableCell>
                  <TableCell align="right">£{sale.purchaseCost.toFixed(2)}</TableCell>
                  <TableCell align="right">{formatDate(sale.purchaseDate)}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box 
  sx={{ 
    borderTop: 1, 
    borderColor: 'divider',
    py: 1.5,  // Reduced padding
    px: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }}
>
  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
    <Typography variant="subtitle2" color="text.secondary">
      Total Sales
    </Typography>
    <Typography variant="h6" sx={{ fontWeight: 'medium' }}>
      £{accountBalance.toFixed(2)}
    </Typography>
  </Box>

  <TablePagination
    component="div"
    count={recentSales.length}
    rowsPerPage={salesRowsPerPage}
    page={salesPage}
    onPageChange={handleSalesChangePage}
    onRowsPerPageChange={handleSalesChangeRowsPerPage}
    rowsPerPageOptions={[5, 10, 25]}
    sx={{
      '.MuiTablePagination-toolbar': {
        minHeight: '48px',  // Reduced height
      },
      '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
        margin: 0,  // Remove margin
      }
    }}
  />
</Box>
    </Paper>
  );
}

export default SalesTable;